import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { paginationGetters, paginationItemsGetter } from '@/store/pagination'
import { Survey } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new Survey(data)
})

const { getPagination, hasMorePage, getTotalPagination } = paginationGetters()
const getPaginationSurveys = paginationItemsGetter(itemGetter)

export default {
  getAll,
  getCollection,
  getSurvey: itemGetter,
  getPagination,
  hasMorePage,
  getTotalPagination,
  getPaginationSurveys,
  getResume: (state) => state.resume,
}
